// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.player-component .player-wrapper {
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
}
.player-component .react-player {
  background: var(--base_color1);
  position: absolute;
  top: 0;
  left: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Player/index.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,mBAAA,EAAA,qCAAA;AAAJ;AAEE;EACE,8BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAAJ","sourcesContent":[".player-component {\n  .player-wrapper {\n    position: relative;\n    padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */\n  }\n  .react-player {\n    background: var(--base_color1);\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
